/* eslint-disable @typescript-eslint/no-explicit-any */
import { Filters } from './request-types'

type ListParams = { filters?: Filters; persist?: boolean }

function buildQueryKeys(label: string) {
  const keys = {
    all: [label],
    details: () => [...keys.all, 'detail'],
    lists: () => [...keys.all, 'list'],
    detail: (
      { id, filters, persist = false }: { id: string } & ListParams,
      modifiers: any[] = [],
    ) => [...keys.details(), id, filters, modifiers, { persist }],
    list: (
      { filters, persist = false }: ListParams = {},
      modifiers: any[] = [],
    ) => [...keys.lists(), filters, modifiers, { persist }],
  }
  return keys
}

export default {
  accounts: buildQueryKeys('accounts'),
  billingEvents: buildQueryKeys('billingEvents'),
  customers: buildQueryKeys('customers'),
  customVariableCategories: buildQueryKeys('customVariableCategories'),
  customVariables: buildQueryKeys('customVariables'),
  customVariableValues: buildQueryKeys('customVariableValues'),
  dataLists: buildQueryKeys('dataLists'),
  dataListEntries: buildQueryKeys('dataListEntries'),
  dataListEntryCells: buildQueryKeys('dataListEntryCells'),
  dataListEntryCellValues: buildQueryKeys('dataListEntryCellValues'),
  dataListColumns: buildQueryKeys('dataListColumns'),
  dataListColumnTypes: buildQueryKeys('dataListColumnTypes'),
  dataListTypes: buildQueryKeys('dataListTypes'),
  docAuditEntries: buildQueryKeys('docAuditEntries'),
  docProjectTags: buildQueryKeys('docProjectTags'),
  docTypes: buildQueryKeys('docTypes'),
  documents: buildQueryKeys('documents'),
  documentChips: buildQueryKeys('documentChips'),
  documentComments: buildQueryKeys('documentComments'),
  documentFlags: buildQueryKeys('documentFlags'),
  documentRows: buildQueryKeys('documentRows'),
  documentRowValues: buildQueryKeys('documentRowValues'),
  documentWorkflowStates: buildQueryKeys('documentWorkflowStates'),
  events: buildQueryKeys('events'),
  exportJobs: buildQueryKeys('exportJobs'),
  fieldRules: buildQueryKeys('fieldRules'),
  fieldTypeRules: buildQueryKeys('fieldTypeRules'),
  flagTypes: buildQueryKeys('flagTypes'),
  groups: buildQueryKeys('groups'),
  importerEmails: buildQueryKeys('importerEmails'),
  infoTypes: buildQueryKeys('infoTypes'),
  infoTypeNamespaces: buildQueryKeys('infoTypeNamespaces'),
  integrations: buildQueryKeys('integrations'),
  integrationTypes: buildQueryKeys('integrationTypes'),
  integrationLiveListTypes: buildQueryKeys('integrationLiveListTypes'),
  languages: buildQueryKeys('languages'),
  logEntries: buildQueryKeys('logEntries'),
  metricLogs: buildQueryKeys('metricLogs'),
  metrics: buildQueryKeys('metrics'),
  originTypes: buildQueryKeys('originTypes'),
  organizations: buildQueryKeys('organizations'),
  poLineItemMatchReasons: buildQueryKeys('poLineItemMatchReasons'),
  poLineItemMatches: buildQueryKeys('poLineItemMatches'),
  orgCredentials: buildQueryKeys('orgCredentials'),
  orgCredentialTypes: buildQueryKeys('orgCredentialTypes'),
  orgTypes: buildQueryKeys('orgTypes'),
  orgWorkflowMetricReports: buildQueryKeys('orgWorkflowMetricReports'),
  projectCategories: buildQueryKeys('projectCategories'),
  projectDocumentRules: buildQueryKeys('projectDocumentRules'),
  projectDocumentRuleTypes: buildQueryKeys('projectDocumentRuleTypes'),
  projectDynamoSettings: buildQueryKeys('projectDynamoSettings'),
  projectGrids: buildQueryKeys('projectGrids'),
  projectGridFields: buildQueryKeys('projectGridFields'),
  projectGridFieldRules: buildQueryKeys('projectGridFieldRules'),
  projectGridFieldTypes: buildQueryKeys('projectGridFieldTypes'),
  projectLinkedModels: buildQueryKeys('projectLinkedModels'),
  projectLinkedModelInfoTypes: buildQueryKeys('projectLinkedModelInfoTypes'),
  projectMappings: buildQueryKeys('projectMappings'),
  projectMappingFields: buildQueryKeys('projectMappingFields'),
  projectMappingTypes: buildQueryKeys('projectMappingTypes'),
  projectModels: buildQueryKeys('projectModels'),
  projectModelTypes: buildQueryKeys('projectModelTypes'),
  projectModelTypeFieldTypeRestrictions: buildQueryKeys(
    'projectModelTypeFieldTypeRestrictions',
  ),
  projectModelTrainingFields: buildQueryKeys('projectModelTrainingFields'),
  projectModelVersions: buildQueryKeys('projectModelVersions'),
  projectModelVersionCategories: buildQueryKeys(
    'projectModelVersionCategories',
  ),
  projectModelVersionFields: buildQueryKeys('projectModelVersionFields'),
  projectFeatures: buildQueryKeys('projectFeatures'),
  projectProjectFeatures: buildQueryKeys('projectProjectFeatures'),
  projectTags: buildQueryKeys('projectTags'),
  projectTemplates: buildQueryKeys('projectTemplates'),
  projectTemplateVersions: buildQueryKeys('projectTemplateVersions'),
  projects: buildQueryKeys('projects'),
  pubModels: buildQueryKeys('pubModels'),
  pubModelVersions: buildQueryKeys('pubModelVersions'),
  rowValueFlags: buildQueryKeys('rowValueFlags'),
  rules: buildQueryKeys('rules'),
  savedViews: buildQueryKeys('savedViews'),
  teams: buildQueryKeys('teams'),
  teamUsers: buildQueryKeys('teamUsers'),
  teamVisibleOrgs: buildQueryKeys('teamVisibleOrgs'),
  userInteractionMetricReports: buildQueryKeys('userInteractionMetricReports'),
  users: buildQueryKeys('users'),
  workflows: buildQueryKeys('workflows'),
  workflowStates: buildQueryKeys('workflowStates'),
  workflowStateActions: buildQueryKeys('workflowStateActions'),
  workflowStateActionTypes: buildQueryKeys('workflowStateActionTypes'),
  workflowStateTypes: buildQueryKeys('workflowStateTypes'),
  workflowStateEvents: buildQueryKeys('workflowStateEvents'),
}
